/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_Meta_DescriptionInputs */

const ja_playdata_sample_meta_description = /** @type {(inputs: Playdata_Sample_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAのeスポーツ大会分析レポートのサンプルを無料でご覧いただけます。`)
};

const en_playdata_sample_meta_description = /** @type {(inputs: Playdata_Sample_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download a free sample of the PLAYDATA esports event report.`)
};

/**
* | output |
* | --- |
* | "Download a free sample of the PLAYDATA esports event report." |
*
* @param {Playdata_Sample_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_sample_meta_description = /** @type {((inputs?: Playdata_Sample_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_meta_description(inputs)
	return en_playdata_sample_meta_description(inputs)
});